import { Component, EventEmitter, inject, input, Output, ChangeDetectionStrategy } from "@angular/core";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";
import { DateTime } from "luxon";
import { TranslateModule } from "@ngx-translate/core";
import { HasPermissionDirective } from "../../directives/has-permission/has-permission.directive";
import { PermissionService } from "../../../services/api/permission/permission.service";
import { ImageListItemConfig } from "../../../models/ui/image";

@Component({
  standalone: true,
  selector: "app-image-list-item",
  imports: [SvgIconComponent, HasPermissionDirective, TranslateModule],
  templateUrl: "./image-list-item.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./image-list-item.component.scss",
})
export class ImageListItemComponent {
  public config = input<ImageListItemConfig>();
  public hideDelete = input<boolean>(false);
  public hideEdit = input<boolean>(false);
  public hideLabel = input<boolean>(false);
  @Output() private openEvent = new EventEmitter<string>();
  @Output() private editEvent = new EventEmitter<string>();
  @Output() private deleteEvent = new EventEmitter<Event>();
  public permissions = inject(PermissionService);

  public convertToTimeString(timestamp: number | undefined) {
    if (timestamp !== undefined) {
      const date = DateTime.fromMillis(timestamp);
      return date.toFormat("dd.MM.yyyy HH:mm");
    } else {
      return "";
    }
  }
  public onEditClick() {
    this.editEvent.emit("");
  }

  public onDeleteClick(event: Event) {
    this.deleteEvent.emit(event);
  }

  public onOpenClick() {
    this.openEvent.emit("");
  }
}
